export default "<div class=\"sidebar\">\n  <app-nav-menu (onToggleMenu)=\"toggleMenu()\"></app-nav-menu>\n</div>\n"